module.exports = __webpack_public_path__ + "img/rosemount-smart-pressure-gauge-front.60072032.png";